<template>
    <div class="pricing-area" id="planos">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="section-title text-center">
                        <h1>Nossos <span>Planos</span></h1>
                        <p>Nossos planos não tem custo de implantação e você pode pagar mensalmente. <br>
                            Experimente gratuitamente qualquer um dos planos por até {{ app.dias_gratis }} dias.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="periodo-planos col-md-12 col-sm-12 col-lg-12">
                    <ul>
                        <li 
                            class="active" 
                            periodo="A" 
                            :plano="grupoPlano.GruposPlano.id"
                        >
                            Anual
                        </li>
                        <li 
                            periodo="S" 
                            :plano="grupoPlano.GruposPlano.id"
                        >
                            Semestral
                        </li>
                        <li 
                            periodo="T" 
                            :plano="grupoPlano.GruposPlano.id"
                        >
                            Trimestral
                        </li>
                        <li 
                            periodo="M" 
                            :plano="grupoPlano.GruposPlano.id"
                        >
                            Mensal
                        </li>
                    </ul>
                </div>
                <div 
                    v-for="(plano, iPlano) in planos"
                    :key="iPlano"
                    class="col-md-3 col-sm-3 col-lg-3"
                >
                    <div class="single-price-package">
                        <div 
                            class="price-title"
                            :class="plano.Plano.classe"
                        >
                            <h3>
                                {{ plano.Plano.nome }}
                            </h3>
                            <div class="price">
                                <h4>
                                    <span 
                                        :id="'plano-' + plano.Plano.id" 
                                        class="text-large"
                                    >
                                        R$ {{ plano.Plano.valor }}
                                    </span>
                                </h4>
                                <p><span class="text-bottom">/mês</span></p>
                            </div>
                        </div>
                        <div class = "price-body">
                            <ul>
                                <li>Gestão comercial completa</li>
                                <li>Acessos simultâneos ilimitados</li>
                                <li>Suporte técnico</li>
                                <li>Espaço ilimitado</li>
                                <li
                                    v-for="(recurso, iRecurso) in plano.Recurso"
                                    :key="iRecurso"
                                >
                                    <template
                                        v-if="recurso.referencia == 'usuarios'"
                                    >
                                        <div
                                            v-if="recurso.PlanosRecurso.permissao >= 100"
                                        >
                                            Usuários ilimitados
                                        </div>
                                        <div
                                            v-else
                                            v-html="formataPermissaoUsuario(recurso)"
                                        />
                                    </template>
                                    <template
                                        v-else-if="recurso.referencia == 'lojas'"
                                    >
                                        <div
                                            v-if="recurso.PlanosRecurso.permissao >= 100"
                                        >
                                            Lojas ilimitados
                                        </div>
                                        <div
                                            v-else
                                            v-html="formataPermissaoLoja(recurso)"
                                        />
                                    </template>
                                    <div
                                        v-else
                                        v-html="formataPermissaoNome(recurso)"
                                    />
                                </li>
                                <li class="plan-action"></li>
                            </ul>
                            <div class="price-btn">
                                <a 
                                    :href="'/cadastro/?plano=' + plano.Plano.id" 
                                    class="button"
                                >
                                    Experimentar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['app', 'grupoPlano', 'planos'],
    methods: {
        formataPermissaoUsuario(recurso){
            let retorno = ''
            retorno += recurso.PlanosRecurso.permissao  
            retorno += ' usuário'
            retorno += recurso.PlanosRecurso.permissao > 1 ? 's' : ''
            return retorno
        },
        formataPermissaoLoja(recurso){
            let retorno = ''
            retorno += recurso.PlanosRecurso.permissao  
            retorno += ' loja'
            retorno += recurso.PlanosRecurso.permissao > 1 ? 's' : ''
            return retorno
        },
        formataPermissaoNome(recurso){
            return recurso.PlanosRecurso.permissao == 1 ? recurso.nome : '<s>' + recurso.nome + '</s>'
        },
    },
}
</script>